import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const go = (d) => setI((prev) => (prev + d + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section data-testid="testimonials" className="bg-[#FBF9F6] py-24 md:py-40">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <span className="eyebrow">Clients</span>
        </Reveal>
        <div className="min-h-[280px] md:min-h-[240px] flex items-center justify-center mt-8">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              data-testid="testimonial-quote"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <p className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight italic">
                "{t.quote}"
              </p>
              <footer className="mt-10">
                <div className="text-base font-medium">{t.name}</div>
                <div className="text-sm text-[#8C7A6B] tracking-wide mt-1">{t.role}</div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
        <div className="flex items-center justify-center gap-4 mt-10">
          <button data-testid="testimonial-prev" onClick={() => go(-1)} className="w-12 h-12 rounded-full border border-[#E5E0D8] flex items-center justify-center hover:bg-[#1A1A1A] hover:text-[#FBF9F6] transition-colors duration-500">
            <ArrowLeft size={18} />
          </button>
          <button data-testid="testimonial-next" onClick={() => go(1)} className="w-12 h-12 rounded-full border border-[#E5E0D8] flex items-center justify-center hover:bg-[#1A1A1A] hover:text-[#FBF9F6] transition-colors duration-500">
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
